
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'DisplayItem',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: [String, null] as PropType<string | null>,
      default: null
    },
    image: {
      type: [String, null] as PropType<string | null>,
      default: null
    },
    showAvatar: {
      type: Boolean,
      default: true
    },
    defaultIcon: {
      type: String,
      default: 'mdi-help'
    }
  }
})
